import React from 'react';
import { BookOpen, Video, Users, Award, Clock, Laptop } from 'lucide-react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const Academy = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      {/* Hero */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block bg-[#D3FF62] px-4 py-2 rounded-full mb-6">
              <span className="text-[#004534] font-semibold text-sm">Online Learning Platform</span>
            </div>
            <h1 className="display-large mb-6">FITNOVEXA Academy</h1>
            <p className="body-large mb-8">
              Master Personal Trainer Skills and business development through our comprehensive online learning platform. 
              Self-paced courses, live webinars, and expert instruction from industry leaders.
            </p>
            <Link to="/contact" className="btn-primary">
              Explore Courses
            </Link>
          </div>
        </div>
      </section>

      {/* Learning Features */}
      <section className="py-16 md:py-24 bg-[#FAFAFF]">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-1 mb-4">Learning Experience</h2>
            <p className="body-large">Flexible, comprehensive, and results-driven education</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="network-card text-center">
              <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Clock size={32} className="text-[#004534]" />
              </div>
              <h3 className="heading-3 mb-3">Self-Paced Learning</h3>
              <p className="body-medium">Study on your schedule with lifetime access to course materials</p>
            </div>
            <div className="network-card text-center">
              <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Video size={32} className="text-[#004534]" />
              </div>
              <h3 className="heading-3 mb-3">Live Webinars</h3>
              <p className="body-medium">Interactive sessions with industry experts and Q&A opportunities</p>
            </div>
            <div className="network-card text-center">
              <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <Award size={32} className="text-[#004534]" />
              </div>
              <h3 className="heading-3 mb-3">Certifications</h3>
              <p className="body-medium">Earn recognized credentials to advance your career</p>
            </div>
          </div>
        </div>
      </section>

      {/* Course Offerings */}
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-1 mb-4">Course Catalog</h2>
            <p className="body-large">Comprehensive curriculum covering all aspects of fitness, wellness and recreation industry</p>
          </div>

          <div className="network-grid">
            {mockData.academyCourses.map((course, index) => {
              const icons = [BookOpen, Laptop, Users, Award, Video, BookOpen];
              const IconComponent = icons[index % icons.length];
              return (
                <div key={index} className="network-card">
                  <div className="bg-[#D3FF62] w-16 h-16 rounded-2xl flex items-center justify-center mb-4">
                    <IconComponent size={32} className="text-[#004534]" />
                  </div>
                  <h3 className="network-card-title">{course}</h3>
                  <p className="network-card-content mb-4">
                    Comprehensive training in {course.toLowerCase()} with practical applications.
                  </p>
                  <button className="btn-secondary text-sm py-2">
                    Learn More
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-16 md:py-24 bg-[#EDEDFE]">
        <div className="container">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="heading-1 mb-6">Start Learning Today</h2>
            <p className="body-large mb-8">
              You are ready to transform your careers with FITNOVEXA Academy. 
              Contact us to learn more about our courses and get started.
            </p>
            <Link to="/contact" className="btn-primary">
              Get Started
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Academy;